import { Toolbar, Typography } from '@mui/material';
import { ErrorBoundary, showReportDialog } from '@sentry/react';
import { ErrorBoundaryProps } from '@sentry/react/types/errorboundary';
import { useRef } from 'react';


export function SentryErrorBoundary(props: Omit<ErrorBoundaryProps, 'onError' | 'fallback'>) {
    const debounceTimeoutRef = useRef<NodeJS.Timeout>();

    return (
        <ErrorBoundary
            onError={(error, componentStack, eventId) => {
                function doClearTimeout() {
                    clearTimeout(debounceTimeoutRef.current!);
                    debounceTimeoutRef.current = undefined;
                }

                if (!debounceTimeoutRef.current) { // Prevent the dialog from showing multiple times for duped errors
                    showReportDialog({ eventId });

                    debounceTimeoutRef.current = setTimeout(doClearTimeout, 300);
                } else {
                    doClearTimeout();

                    debounceTimeoutRef.current = setTimeout(doClearTimeout, 300);
                }
            }}
            fallback={(
                <>
                    <Toolbar disableGutters>
                        <Typography
                            variant="h4"
                            component="h1"
                        >
                            An error occurred
                        </Typography>
                    </Toolbar>

                    <Typography
                        component="a"
                        href="/login"
                    >
                        Go to home
                    </Typography>
                </>
            )}
            {...props}
        />
    );
}
